import {
  COMPONENT_HOVER_ENTER,
  COMPONENT_HOVER_LEAVE,
  COMPONENT_SELECTED,
  COMPONENT_DESELECTED,
  DEVICE_SELECTED,
  IS_MOBILE,
  SET_CONTENT_LINK_STATUS,
  SET_MWP_IFRAME_REF,
  UPDATED_CONTENT_CONTEXT,
  UPDATED_HIDDEN_EXPERIMENTS
} from './const';

/**
 * Returns action for canvas stertching
 * @param {string} device - selected device
 * @returns {object} Action Object
 */

export const handleComponentDeselection = () => ({
  type: COMPONENT_DESELECTED
});

export const handleComponentHoverEnter = component => ({
  type: COMPONENT_HOVER_ENTER,
  component
});

export const handleComponentHoverLeave = () => ({
  type: COMPONENT_HOVER_LEAVE
});

export const handleComponentSelection = component => {
  return {
    type: COMPONENT_SELECTED,
    component
  };
};

export const handleDeviceSelected = device => ({
  type: DEVICE_SELECTED,
  device
});

export const handleIsMobileSelection = isMobile => ({
  type: IS_MOBILE,
  isMobile
});

export const setContentLinkStatus = status => ({
  type: SET_CONTENT_LINK_STATUS,
  status
});

export const setMWPIframeRef = ref => ({
  type: SET_MWP_IFRAME_REF,
  ref
});

export const updateContentContextStates = payload => ({
  type: UPDATED_CONTENT_CONTEXT,
  payload
});

export const updateHiddenExperiments = payload => ({
  type: UPDATED_HIDDEN_EXPERIMENTS,
  payload
});
